import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCollapse = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M8 18L12 14L16 18",
		stroke: "currentColor",
		strokeWidth: 2
	}), /* @__PURE__ */ _jsx("path", {
		d: "M8 6L12 10L16 6",
		stroke: "currentColor",
		strokeWidth: 2
	})]
});
const ForwardRef = forwardRef(SvgCollapse);
export { ForwardRef as ReactComponent };
